import { OfferPrices } from "~/applications/OfferSearch/Domain/OfferPrices";

export class AccommodationOffer {
  constructor(
    public readonly unitGroupId: string,
    public readonly basePrices: OfferPrices,
    public readonly isSoldOut: boolean,
  ) {
    Object.freeze(this);
  }
}
